export enum AddressFields {
  None = 0,
  Country = 1,
  State = 2,
  City = 4,
  Street = 8,
  Street2 = 16,
  PostalCode = 32,
  HouseNumber = 64
}

export class AddressFormSettings {
  // tslint:disable-next-line:no-bitwise
  private static readonly defaultFieldsToShow = AddressFields.Country | AddressFields.State | AddressFields.City | AddressFields.Street |
                                                AddressFields.Street2 | AddressFields.PostalCode | AddressFields.HouseNumber;
  // tslint:disable-next-line:no-bitwise
  private static readonly defaultFieldsToRequire = AddressFields.Country | AddressFields.State | AddressFields.City | AddressFields.Street |
                                                   AddressFields.PostalCode | AddressFields.HouseNumber;

  /**
   * Construct settings for address form
   * @param fieldsToShow fields to show, default is to show all
   * @param fieldsToRequire fields to require, default is to require all except street2
   * @param toValidatePostalCode to validate postal code, default is false
   * @param stateRequiredWhileUs To prevent requiring state on demand (while creating Contact)
   */
  constructor(private fieldsToShow: AddressFields = AddressFormSettings.defaultFieldsToShow,
              private fieldsToRequire: AddressFields = AddressFormSettings.defaultFieldsToRequire,
              private toValidatePostalCode: boolean = false,
              public stateRequiredWhileUs: boolean = true

  ) {
  }

  get addressFieldsToShow(): AddressFields {
    return this.fieldsToShow;
  }

  get addressFieldsToRequire(): AddressFields {
    return this.fieldsToRequire;
  }

  get toValidatePostalCodePattern(): boolean {
    return this.toValidatePostalCode;
  }

  public toShowField(field: AddressFields): boolean {
    // tslint:disable-next-line:no-bitwise
    return (this.fieldsToShow & field) === field;
  }

  public toRequireField(field: AddressFields): boolean {
    // tslint:disable-next-line:no-bitwise
    return (this.fieldsToRequire & field) === field;
  }
}
